// extracted by mini-css-extract-plugin
export default {"logger":"styles_logger__szpzN","blink":"styles_blink__Sgigr"};